import { useQuery } from '@tanstack/react-query';
import type { Call, Lead } from '@marnic/shared';
import { api } from '../lib/api';

export interface CallRow extends Call {
  lead: Pick<Lead, 'firstName' | 'lastName' | 'company'> | null;
}

export interface CallsResponse {
  total: number;
  items: CallRow[];
}

export interface RecentCallsFilters {
  leadId?: string;
  phone?: string;
  hasRecording?: 'true' | 'false';
}

export function useRecentCalls(limit: number, filters: RecentCallsFilters = {}) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (filters.leadId) params.set('leadId', filters.leadId);
  if (filters.phone) params.set('phone', filters.phone);
  if (filters.hasRecording) params.set('hasRecording', filters.hasRecording);
  const qs = params.toString();

  return useQuery({
    queryKey: ['calls', 'recent', limit, filters.leadId ?? '', filters.phone ?? '', filters.hasRecording ?? ''],
    queryFn: () => api.get<CallsResponse>(`/calls?${qs}`),
    staleTime: 15_000,
  });
}
